import React, {useEffect, useState} from 'react';
import { ServiceUtils } from '../../Shared/Utils/ServiceUtils';
import { alertService } from '../../Shared/Utils/ToasterUtils';
import { useNavigate } from 'react-router-dom';
import BreadcrumbList from '../../Shared/Components/Breadcrumb/Breadcrumb';
import { Card, Table } from "antd";



const AuditLogs = () => {

  const navigate = useNavigate();

  const [auditLogs, setAuditLogs] = useState({
    tableData: {
        headerContent: [],
        bodyContent: []
    }
  });

const getAuditLogs = () => {
  const payLoad = {}; 
  ServiceUtils.postRequest('auditLogs', payLoad).then(
    (response) => {
      if (response.status === 200 && response?.data.status) {
        let res = JSON.parse(JSON.stringify(response.data?.data));
        setAuditLogs(res)
      } 
      else if(response.status === 401 ){
        navigate('/logout');
      }
      else {
        alertService.error(response.data.message)
      }
    },
    (error) => {
      console.log(error)
    }
  );
}

  useEffect(()=>{
        getAuditLogs()
  },[])

  return (
    <div className="admin-main">
      <Card
        style={{ width: "100%", height: "fit-content" }}
        bodyStyle={{ padding: "10px" }}
      >
        <BreadcrumbList active={[{ label: "Audit Logs", link: "" }]} />
      </Card>
      <Card
        bordered={false}
        style={{ margin: "10px" }}
        className="audit-body-card"
      >
        <Table
          columns={auditLogs?.headerContent}
          dataSource={auditLogs?.bodyContent}
          scroll={{
            y: 'calc(100vh - 270px)',
          }}
          pagination={false}
          bordered
        />
      </Card>
    </div>
  );

}

export default AuditLogs;
